import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormDataService } from "../data/form-data.service";
import { SharedDataService } from "../config/shared-data.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-locations",
  templateUrl: "./locations.component.html",
  styleUrls: ["./locations.component.scss"],
})
export class LocationsComponent implements OnInit, OnDestroy {
  locations: Array<any> = [];
  selectedLocation: string;
  isOpenTicket: boolean = false;

  locationInfo: any = {};

  isLoading: boolean = true;

  hasError: boolean = false;

  selectedOptionIndex: any = null;
  private destroyed$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private formDataService: FormDataService,
    private sharedDataService: SharedDataService,
    private route: ActivatedRoute,
    public router: Router
  ) {
    this.initializeComponent();
  }

  private async initializeComponent() {
    this.route.queryParams
      .pipe(takeUntil(this.destroyed$))
      .subscribe((params) => {
        this.isOpenTicket = !!params.open_ticket;
        if (this.isOpenTicket) {
          localStorage.setItem("is_open_ticket", "true");
        }

        if (params.location) {
          localStorage.setItem("location_permalink", params.location);
          this.selectedLocation = params.location;
          if (params.course_id && params.date) {
            localStorage.setItem("course_id_from_url", params.course_id);
            localStorage.setItem("date_url", params.date);
            this.formDataService.activeSteps["step_3"] = true;
            this.router.navigate(["/tickets"], {
              queryParamsHandling: "merge",
            });
            return;
          } else {
            localStorage.removeItem("course_id_from_url");
            localStorage.removeItem("date_url");
            this.formDataService.activeSteps["step_2"] = true;
            this.router.navigate(["/type"], { queryParamsHandling: "merge" });
          }
        } else {
          localStorage.removeItem("course_id_from_url");
          localStorage.removeItem("date_url");
        }
      });

    //no location provided
    if (
      this.selectedLocation !== undefined ||
      (this.selectedLocation && this.selectedLocation === "")
    ) {
      let locationData = {
        permalink: this.selectedLocation,
      };

      this.formDataService.setLocationUrl(locationData);
      if (this.isOpenTicket) {
        this.formDataService.activeSteps["step_3"] = true;
        this.router.navigate(["/tickets"], { queryParamsHandling: "merge" });
      }
    }

    this.formDataService.resetActiveSteps();

    try {
      const res = await this.sharedDataService
        .getLocations()
        .pipe(takeUntil(this.destroyed$))
        .toPromise();

      if (!res || !res.success) {
        this.isLoading = false;
        this.hasError = true;
        return;
      }

      if (this.selectedLocation && res.data) {
        const foundLocation = res.data.locations.find(
          (location) => location.permalink === this.selectedLocation
        );
        if (foundLocation) {
          localStorage.setItem(
            "location_selected",
            JSON.stringify(foundLocation)
          );
        }
      }

      let course_id_url = localStorage.getItem("course_id_from_url");

      if (!course_id_url && this.selectedLocation) {
        this.formDataService.activeSteps["step_1"] = true;
        this.router.navigate(["/type"], { queryParamsHandling: "merge" });
      } else if (course_id_url && this.selectedLocation) {
        this.formDataService.activeSteps["step_1"] = true;
        this.router.navigate(["/calendar"], { queryParamsHandling: "merge" });
      }

      this.locations = res.data.locations;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.hasError = true;
      console.error("Error loading locations:", error);
    }
  }

  ngOnInit() {
    this.locationInfo = 0; //set disabled default
  }

  locationChange(ev) {
    this.selectedOptionIndex = ev.target.selectedIndex - 1;
  }

  addLocation(form) {
    if (!form.valid) {
      this.hasError = true;
      return;
    }

    if (this.selectedOptionIndex === null) {
      this.hasError = true;
      return;
    }

    let location = this.locations[this.selectedOptionIndex];

    let locationData = {
      id: location.id,
      permalink: location.permalink,
      name: location.name,
    };

    this.formDataService.setLocationUrl(locationData);
    this.sharedDataService.changeMessage(locationData.name);
    this.formDataService.activeSteps["step_1"] = true;

    //Memorizzo la location nel localStorage
    localStorage.setItem("location_selected", JSON.stringify(location));
    localStorage.setItem("location_permalink", locationData.permalink);
    this.router.navigate(["/type"], { queryParamsHandling: "merge" });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
